import loginFormModel from './loginFormModel';

const { formField: { email, password } } = loginFormModel;

const loginFormIntialValues = {
  [email.name]: '',
  [password.name]: ''
};

export default loginFormIntialValues;